<template>
  <div class="container">
    <div class="header" @click.prevent="toggle">
      <slot name="title"></slot>
      <div class="toggle-button">
        <div>{{ isToggled ? "收起" : "展开" }}</div>
        <div class="img-wrapper">
          <img
            class="img"
            :src="
              isToggled ? require('@/assets/imgs/arrow_up.png') : require('@/assets/imgs/arrow_down.png')
            "
          />
        </div>
      </div>
    </div>
    <div class="content" v-show="isToggled">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollapseCard",
  props: {
    toggled: {
      type: Boolean,
      default: false
    },
    name: String,
  },
  mounted() {
    const toggled = localStorage.getItem(`${this.name}-toggled`);
    if (toggled !== undefined) {
      this.isToggled = !!Number(toggled);
    } else {
      this.isToggled = this.toggled;
    }
  },
  data() {
    return {
      name: "",
      isToggled: this.toggled,
    };
  },
  methods: {
    submit() {
      if (this.value) {
        this.$emit("save", this.value);
      }
      this.toggler = false;
      this.value = "";
    },
    clickAdd() {
      this.toggler = true;
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.input.focus();
      });
    },
    toggle() {
      const value = !this.isToggled;
      this.isToggled = value;
      if (this.name) {
        localStorage.setItem(`${this.name}-toggled`, Number(value));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/fonts.scss";
@import "../../common/colors.scss";

.container {
  padding: 32px;
  background: $cod-gray;
  border-radius: 16px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.content {
  margin: 24px 0 0 0;
  border-top: 1px solid rgba($manatee, 0.2);
  padding: 24px 0 0 0;
}

.toggle-button {
  display: flex;
  align-items: center;
  @include fontSize-14;
  @include regularFont;
  color: $abbey;
}

.img-wrapper {
  margin: 0 0 0 8px;
  width: 16px;
  height: 16px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
